













  import { defineComponent, computed } from 'vue'
  import useCurrentInstance from '~/utils/useCurrentInstance'

  export default defineComponent({
    name: 'OneProductStocksLabel',
    props: {
      stockVisibilityModeHidden: {
        type: Boolean,
        default: false,
      },
      available: {
        type: Boolean,
        default: false,
      },
      unit: {
        type: String,
        default: '',
      },
      labelClass: {
        type: String,
        default: '',
      },
      wrapperClass: {
        type: String,
        default: 'd-flex justify-content-center align-items-center',
      },
      quantity: {
        type: Number,
        required: true,
      },
    },
    setup(props) {
      const vm = useCurrentInstance()

      const stockVisibilityModeLabel = (available: boolean = false): string => {
        return available
          ? vm.$t('stock_visibility_mode.available') as string
          : vm.$t('stock_visibility_mode.unavailable') as string
      }

      const availableLabel = computed(() => {
        return stockVisibilityModeLabel(props.available)
      })

      const quantityValue = computed(() => {
        if (props.stockVisibilityModeHidden) {
          return props.available ? 1 : 0
        }
        return props.quantity
      })

      return {
        availableLabel,
        quantityValue,
      }
    },
  })
